import React from 'react'
import { color, spacer, PlayIcon, Button, typography } from 'stylist'
import styled, { css } from 'react-emotion'
import ClipCard from './ClipCard'
import { formatTime } from 'utils/time'
import withFeature from 'components/withFeature'
import { SlideLeft, FadeIn } from 'components/animation'

const Highlights = withFeature(styled.div`
  display: grid;
  grid-row-gap: ${spacer('4')};
  grid-template-areas:
    'highlightTitle'
    'highlightNote'
    'highlightClips';

  ${({ hasFeature, theme }) =>
    !hasFeature('demo_video_page') &&
    css`
      margin-top: ${spacer(4, { theme })};
    `};
`)

const Title = styled.div`
  grid-area: highlightTitle;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`
const Label = styled.div`
  ${typography('title1')};
`
const Actions = styled.div``

const Note = styled.div`
  grid-area: highlightNote;
`
const Clips = styled.div`
  grid-area: highlightClips;
`
const PlayButton = styled(Button)`
  margin-right: ${spacer(4)};

  > svg {
    margin-top: -1px;
  }
`

const ClipMeta = styled.span`
  color: ${color('cadet')};
  ${typography('body1')};
`

const totalClipDuration = clips =>
  clips
    .map(clip => clip.endTime - clip.startTime)
    .reduce((total, num) => total + num, 0)
const formattedDuration = clips => formatTime(totalClipDuration(clips))
const isCurrentClip = (clip, currentTime) =>
  currentTime && clip.startTime < currentTime && clip.endTime > currentTime

const ClipsContainer = ({
  clips = [],
  clipsToShow = [],
  duration,
  seekToTime,
  currentTime
}) =>
  clips.length ? (
    <FadeIn>
      <Highlights>
        <Title>
          <Label>Key Moments</Label>
          <Actions>
            <PlayButton
              size="sm"
              onClick={() => seekToTime(clipsToShow[0].startTime)}
              disabled={!Boolean(clipsToShow.length)}
              kind="ghost"
            >
              <PlayIcon size="1em" /> Play Clips
            </PlayButton>
            <ClipMeta>
              {clipsToShow.length} Clips {formattedDuration(clipsToShow)}
            </ClipMeta>
          </Actions>
        </Title>
        <Note>
          We thought you might find these clips useful. If you agree or
          disagree, please let us know by clicking thumbs up or down. Your
          feedback will help us select better clips for you next time!
        </Note>
        <Clips>
          {clips.map((clip, index) => (
            <SlideLeft key={index}>
              <ClipCard
                clip={clip}
                title={`Clip ${index + 1}`}
                duration={duration}
                onClick={() => seekToTime(clip.startTime)}
                dark={isCurrentClip(clip, currentTime)}
              />
            </SlideLeft>
          ))}
        </Clips>
      </Highlights>
    </FadeIn>
  ) : (
    <FadeIn>
      <Highlights>
        <Title>
          <Label>Key Moments</Label>
        </Title>
        <Note>
          Our robots are hard at work collecting insights from your video. Check
          back soon!
        </Note>
      </Highlights>
    </FadeIn>
  )

export default ClipsContainer



// WEBPACK FOOTER //
// ./src/routes/video/components/ClipsContainer.js